import React from 'react';

import { isNil, noop } from 'lodash';

import { TagProps } from './types';

import IconButton from '~/core/atoms/Buttons/IconButton';
import CloseIcon from '~/core/iconComponents/icons/CloseIcon';
import cn from '~/utils/cn';

const Tag: React.FC<TagProps> = ({
  text,
  icon,
  Wrapper,
  shouldDisplayClose = false,
  onClose = noop,
  className = '',
  disabled = false,
}) => {
  // Base styling classes
  const baseClasses = [
    'align-middle',
    'items-center',
    'inline-flex',
    'text-sm',
    'px-8',
    'py-2',
    'border',
    'border-grey-200',
    'rounded-full',
    'max-w-[150px]',
    'bg-white',
    'transition-colors',
    'cursor-default',
  ];

  const conditionalClasses = [disabled ? 'opacity-50 cursor-not-allowed' : ''];

  if (shouldDisplayClose) {
    conditionalClasses.push('pr-4');
  }

  const res = (
    <div
      className={cn(...baseClasses, ...conditionalClasses, className)}
      title={text}
      role="group"
      aria-label={shouldDisplayClose ? `Tag: ${text}. Press tab to access remove button` : `Tag: ${text}`}
    >
      {icon && (
        <div className="flex-shrink-0 pr-4" aria-hidden="true">
          {icon}
        </div>
      )}
      {text && <span className="truncate">{text}</span>}
      {shouldDisplayClose && (
        <IconButton
          onClick={onClose}
          disabled={disabled}
          size="sm"
          round
          className={cn('ml-4 h-16 w-16 flex-shrink-0')}
          aria-label={`Remove ${text} tag`}
        >
          <CloseIcon size={12} className="text-grey-600" />
        </IconButton>
      )}
    </div>
  );

  if (!isNil(Wrapper)) {
    return <Wrapper>{res}</Wrapper>;
  }
  return res;
};

export default Tag;
